import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import {
  isEmptyProcessWindowList,
  changeProcessShareFlag,
  compareTableData,
} from '@/vue-caas/utils/process';

const baseURI = config.companyApiUrl;
const setupURI = config.setupApiUrl;
const isDlb = config.isDlb;

const partnerStoreModule = {
  // namespaced: false,

  state: {
    partnerList: [],
    partnerListTemp: [],
    partnerUseList: [],
    partnerCheckResult: {},
    filter: {},
    partnerChange: {},
  },
  mutations: {
    SET_STORE_PARTNER_LIST(state, partnerList) {
      if (
        JSON.stringify(state.partnerListTemp) !== JSON.stringify(partnerList) &&
        !isEmptyProcessWindowList()
      ) {
        changeProcessShareFlag('PRNR');
      }
      partnerList === null ? (state.partnerList = []) : (state.partnerList = partnerList);
      partnerList === null ? (state.partnerListTemp = []) : (state.partnerListTemp = partnerList);
    },
    SET_STORE_PARTNER_USE_LIST(state, partnerUseList) {
      state.partnerChange = compareTableData(state.partnerUseList, partnerUseList, 'prnrId');
      partnerUseList === null
        ? (state.partnerUseList = [])
        : (state.partnerUseList = partnerUseList);
    },
    SET_STORE_CHECK_PARTNER(state, partner) {
      state.partnerCheckResult = partner;
    },
    SET_STORE_PARTNER_LIST_FILTER(state, filter) {
      let datarows = state.partnerListTemp;
      state.filter = filter;
      let filterBy = state.filter;
      let listResult = [];
      // console.log(JSON.stringify(filterBy, null, 4));
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter((item) => {
          if (filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              // console.log(JSON.stringify(propValue, null, 4));
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
          return false;
        });
      }
      state.partnerList = listResult;
    },
  },
  actions: {
    // 2021.5.12 203728 Return partner list for Company
    getPartnerListByCompany: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/partner/list/company`, params);
        commit('SET_STORE_PARTNER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PARTNER_LIST', null);
        throw err;
      }
    },
    // Check Comm, Folder, Edi, Partner, Map in Workflow ( Master & History ) before delete
    getListUseInWorkflow: async ({ commit }, params) => {
      try {
        const res = await axios.post(`${setupURI}/process/check/listUseInWorkflow`, {
          obj: params.type,
          checkValue: params.value,
          listChk: params.listChk,
        });
        return res.data;
      } catch (err) {
        throw err;
      }
    },
    getPartnerList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/partner/list`, params);
        commit('SET_STORE_PARTNER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PARTNER_LIST', null);
        throw err;
      }
    },
    // 2021.5.12 203728 Return partner list for Dashboard
    getDashBoardPartnerList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/partner/list/dashboard`, params);
        commit('SET_STORE_PARTNER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PARTNER_LIST', null);
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    getPartnerUseList: async ({ commit }) => {
      try {
        const response = await axios.post(`${baseURI}/partner/list/use`);
        // console.log(response.data);
        commit('SET_STORE_PARTNER_USE_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PARTNER_USE_LIST', null);
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    insertPartner: async ({ commit }, params) => {
      try {
        if (params.email && params.email != '') {
          const emailArr = params.email.split('@');
          params.emailF = emailArr[0];
          params.emailT = emailArr[1];
        }

        params.emailF === ''
          ? (params.email = '')
          : (params.email = `${params.emailF}@${params.emailT}`);

        const response = await axios.post(`${baseURI}/partner/insert`, params);
        // console.log(response.data);
        commit('SET_STORE_PARTNER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PARTNER_LIST', null);
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    updatePartner: async ({ commit }, params) => {
      try {
        params.emailF === ''
          ? (params.email = '')
          : (params.email = `${params.emailF}@${params.emailT}`);

        const response = await axios.post(`${baseURI}/partner/update`, params);
        // console.log(response.data);
        commit('SET_STORE_PARTNER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PARTNER_LIST', null);
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    deletePartner: async ({ commit }, params) => {
      try {
        /**
         * 2021.08.25 203737 SPKA-193 Check delete function for workflow mgmt [Partner]
         * Apply delete dialog for Partner
         */
        const response = await axios.post(`${baseURI}/partner/delete`, params);
        commit('SET_STORE_PARTNER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PARTNER_LIST', null);
        throw err;
      }
    },
    checkPartner: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/partner/check`, params);
        // console.log(response.data);
        commit('SET_STORE_CHECK_PARTNER', response.data);
      } catch (err) {
        commit('SET_STORE_PARTNER_LIST', null);
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    checkEmailPartner: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/partner/checkEmail`, params);
        return response.data;
      } catch (err) {
        commit('SET_STORE_PARTNER_LIST', null);
        throw err;
      }
    },
  },
  getters: {
    partnerList: (state) => state.partnerList,
    partnerUseList: (state) => state.partnerUseList,
    partnerCheckResult: (state) => state.partnerCheckResult,
    partnerChange: (state) => state.partnerChange,
  },
};

export default partnerStoreModule;
